// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  LiveLessons: (t, data?, options?) => t('enum.product.live-lessons.name', data, options),
  LiveLessonsNative: (t, data?, options?) => t('enum.product.live-lessons-native.name', data, options),
  StudyAbroad: (t, data?, options?) => t('enum.product.study-abroad.name', data, options),
  iKnow: (t, data?, options?) => t('enum.product.i-know.name', data, options),
  /* eslint-enable max-len */
};
